import { render, staticRenderFns } from "./Klokjes.vue?vue&type=template&id=deba13d0&scoped=true"
import script from "./Klokjes.vue?vue&type=script&lang=ts"
export * from "./Klokjes.vue?vue&type=script&lang=ts"
import style0 from "./Klokjes.vue?vue&type=style&index=0&id=deba13d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deba13d0",
  null
  
)

export default component.exports